"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadableButton = void 0;
var core_1 = require("@material-ui/core");
var CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
var react_1 = __importDefault(require("react"));
function LoadableButton(props) {
    var children = props.children, loading = props.loading, disabled = props.disabled, other = __rest(props, ["children", "loading", "disabled"]);
    disabled = disabled || loading;
    return (react_1.default.createElement(core_1.Button, __assign({ disabled: disabled }, other), loading ? (react_1.default.createElement("div", { style: { top: 3, position: 'relative' } },
        react_1.default.createElement(CircularProgress_1.default, { size: 30, color: "inherit" }))) : (children)));
}
exports.LoadableButton = LoadableButton;
